import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, ControlContainer, FormControl, Validators } from '@angular/forms';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { AuthenticationService } from '../../services/authentication.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { RegisterType } from 'src/app/shared/models/enums.model';
import { User, Role } from '../../models/user.model';

@Component({
  selector: 'app-user-request-details',
  templateUrl: './user-request-details.component.html',
  styleUrls: ['./user-request-details.component.css']
})
export class UserRequestDetailsComponent implements OnInit {
  RegisterType=RegisterType;
  _extrnalData: any;
  @Input() UserRequestDetailsformGroup: FormGroup;
  @Input() IsReadOnly: boolean;
  @Input() SubmitFlag: boolean;
  @Input() IsCustomerName: boolean;
  @Input() IsFaxOptional: boolean;
  role = Role;
  // @Input() extrnalData: any;
  @Input() set extrnalData(value: any) {
    this._extrnalData = value;
    this.CreateFormGroup();
    this.CheckReadOnly();
    if (this._extrnalData && this.IsReadOnly) {
      this.UserRequestDetailsformGroup.controls['MobileNumber'].setValue(this._extrnalData.MobileNumber);
      this.UserRequestDetailsformGroup.controls['Fax'].setValue(this._extrnalData.Fax);
      if (this.IsCustomerName) {
        this.UserRequestDetailsformGroup.controls['CustomerName'].setValue(this._extrnalData.CustomerName);
      }
    }
  }
  get extrnalData() {
    return this._extrnalData;
  }
  currentUser: User;
  charRegex: string = '^[a-zA-Z\\s]*$';
  numberRegex: string = '^[0-9]*$';

  constructor(private controlContainer: ControlContainer, private http: HttpServices, private authenticationService: AuthenticationService, private global: GlobalServices) {
    this.authenticationService.currentUser.subscribe(u => this.currentUser = u);
    //this.currentUser = this.global.user;

  }

  ngOnInit() {
    if (this.UserRequestDetailsformGroup != null && this.UserRequestDetailsformGroup != undefined) {
      this.CreateFormGroup();
      this.CheckReadOnly();
      // if (this.extrnalData && this.IsReadOnly) {
      //   this.UserRequestDetailsformGroup.controls['MobileNumber'].setValue(this.extrnalData.Mobile);
      //   this.UserRequestDetailsformGroup.controls['Fax'].setValue(this.extrnalData.Fax);
      //   if (this.IsCustomerName) {
      //     this.UserRequestDetailsformGroup.controls['CustomerName'].setValue(this.extrnalData.FullName);
      //   }
      // } else
      if (this.currentUser && !this.IsReadOnly) {
        if (this.currentUser.RegisterTypeId == RegisterType.Agent) {
          this.UserRequestDetailsformGroup.controls['MobileNumber'].setValue('+2' + this.currentUser.Phone1);

        }
        if (this.currentUser.RegisterTypeId == RegisterType.Supplier) {

          this.UserRequestDetailsformGroup.controls['MobileNumber'].setValue('+2' + this.currentUser.Phone);

        }
        if (this.currentUser.RegisterTypeId == RegisterType.PortalUser){

          this.UserRequestDetailsformGroup.controls['MobileNumber'].setValue(this.currentUser.Mobile);
        }
        if (this.IsCustomerName && this.currentUser.RegisterTypeId == RegisterType.PortalUser) {
          this.UserRequestDetailsformGroup.controls['CustomerName'].setValue(this.currentUser.FullName);
        }
        if (this.IsCustomerName && this.currentUser.RegisterTypeId == RegisterType.Agent) {
          this.UserRequestDetailsformGroup.controls['CustomerName'].setValue(this.currentUser.Name);
        }
        if (this.IsCustomerName && this.currentUser.RegisterTypeId == RegisterType.Supplier) {
          this.UserRequestDetailsformGroup.controls['CustomerName'].setValue(this.currentUser.CompanyName);
        }
        this.UserRequestDetailsformGroup.controls['Fax'].setValue(this.currentUser.Fax);
      }
      else {
        //Simulated Part Should be deleted on sharepoint environment.
        this.UserRequestDetailsformGroup.controls['MobileNumber'].setValue(this.global.user.Mobile);
        this.UserRequestDetailsformGroup.controls['Fax'].setValue(this.global.user.Fax);

        if (this.IsCustomerName) {
          this.UserRequestDetailsformGroup.controls['CustomerName'].setValue(this.global.user.FullName);

        }
      }
    }
  }

  get Validate() {
    return this.UserRequestDetailsformGroup.controls;
  }

  CreateFormGroup() {
    this.UserRequestDetailsformGroup.addControl('MobileNumber', new FormControl('', [Validators.required]));
    if (this.IsFaxOptional) {
      this.UserRequestDetailsformGroup.addControl('Fax', new FormControl('', [Validators.pattern(this.numberRegex)]));
    }

    this.UserRequestDetailsformGroup.addControl('Fax', new FormControl('', [Validators.required, Validators.pattern(this.numberRegex)]));

    if (this.IsCustomerName) {
      this.UserRequestDetailsformGroup.addControl('CustomerName', new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern(this.charRegex), CustomValidators.textSpaceValidator()]));
    }
  }

  CheckReadOnly() {
    if (this.IsReadOnly) {
      this.UserRequestDetailsformGroup.disable();
    }
  }
}
